"use client";

import { api } from "@/api";
import useSWR from "swr";

const fetchReferralCode = async () => {
  const res = await api.user.getReferralLink();
  return res.data?.code || "";
};

export function useReferralCode(enabled: boolean) {
  const { data, isLoading, error } = useSWR<string>(
    enabled ? "referral-code" : null,
    fetchReferralCode,
    {
      revalidateOnFocus: false,
      revalidateOnReconnect: false,
      revalidateIfStale: false,
    }
  );

  return {
    referralCode: data ?? "",
    loading: enabled ? isLoading : false,
    error,
  };
}
